import { mapActions, mapState } from 'vuex'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const admissionComputed = { ...mapState('admissions', {admissions: (state) => state.admissions })}
export const admissionMethods = mapActions('admissions', ['fetchAdmissions'])

export const countriesComputed = { ...mapState('countries', {countries: (state) => state.countries })}
export const countriesMethods = mapActions('countries', ['fetchCountries'])

export const schoolclassComputed = { ...mapState('schoolclasses', {schoolclasses: (state) => state.schoolclasses })}
export const schoolclassMethods = mapActions('schoolclasses', ['fetchSchoolClasses'])
